const graduateGradeLabels: Record<string, string> = {
  院1: "M1(院1)",
  院2: "M2(院2)",
  院3: "D1(院3)",
  院4: "D2(院4)",
  院5: "D3(院5)",
};

/**
 * DBに保存している学年コードを、画面表示用の表記に変換します。
 * 院1〜院5は内部値を変えず、修士・博士課程の年次を併記します。
 */
export function formatAcademicGrade(
  grade: string | null | undefined,
  emptyLabel = "—"
) {
  if (!grade) return emptyLabel;
  return graduateGradeLabels[grade] ?? grade;
}

export function getGraduateGradeLabel(grade: string) {
  return graduateGradeLabels[grade] ?? grade;
}
